import {
  FolderIcon,
  DocumentTextIcon,
  ShieldCheckIcon,
  CalculatorIcon,
  CogIcon,
  HomeIcon,
  CodeIcon,
} from '@heroicons/react/outline';
import { Location } from 'react-router-dom';

export type MenuItem = {
  name: string;
  href: string;
  icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  current: boolean;
};

export const getDashboardItems = (location: Location): MenuItem[] => [
  {
    name: 'Dashboard',
    href: '/',
    icon: HomeIcon,
    current: location.pathname === '/',
  },
];

export const getNavigationTramitItems = (location: Location): MenuItem[] => [
  {
    name: 'Compraventas',
    href: '/transfers?page=0',
    icon: FolderIcon,
    current: location.pathname.includes('/transfers'),
  },
  {
    name: 'Matriculaciones',
    href: '/registrations?page=0',
    icon: FolderIcon,
    current: location.pathname.includes('/registrations'),
  },
  {
    name: 'Importaciones',
    href: '/generic-procedures/VEHICLE_IMPORT?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes('/generic-procedures/VEHICLE_IMPORT'),
  },
  {
    name: 'Informes',
    href: '/traffic-reports?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes('/traffic-reports'),
  },
  {
    name: 'Duplicados',
    href: '/generic-procedures/DUPLICATE?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes('/generic-procedures/DUPLICATE'),
  },
  {
    name: 'Notificación de venta',
    href: '/generic-procedures/SELL_NOTIFICATION?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes(
      '/generic-procedures/SELL_NOTIFICATION',
    ),
  },
  {
    name: 'Reservas de Dominio',
    href: '/generic-procedures/DOMAIN_RESERVATION?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes(
      '/generic-procedures/DOMAIN_RESERVATION',
    ),
  },
  {
    name: 'Cambio de servicio',
    href: '/generic-procedures/ISOLATED_SERVICE_TYPE_CHANGE?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes(
      '/generic-procedures/ISOLATED_SERVICE_TYPE_CHANGE',
    ),
  },
  {
    name: 'Placas Rojas',
    href: '/generic-procedures/RED_PLATES?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes('/generic-procedures/RED_PLATES'),
  },
  {
    name: 'Placas Verdes',
    href: '/generic-procedures/GREEN_PLATES?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes('/generic-procedures/GREEN_PLATES'),
  },
  {
    name: 'Altas',
    href: '/generic-procedures/VEHICLE_REGISTRATION?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes(
      '/generic-procedures/VEHICLE_REGISTRATION',
    ),
  },
  {
    name: 'Bajas',
    href: '/generic-procedures/VEHICLE_DEREGISTRATION?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes(
      '/generic-procedures/VEHICLE_DEREGISTRATION',
    ),
  },
  {
    name: 'Distintivo Ambiental',
    href: '/generic-procedures/ENVIRONMENTAL_BADGE?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes(
      '/generic-procedures/ENVIRONMENTAL_BADGE',
    ),
  },
  {
    name: 'Rehabilitaciones',
    href: '/generic-procedures/REINSTATEMENT?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes('/generic-procedures/REINSTATEMENT'),
  },
  {
    name: 'Cambios de domicilio',
    href: '/generic-procedures/VEHICLE_ADDRESS_CHANGE?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes(
      '/generic-procedures/VEHICLE_ADDRESS_CHANGE',
    ),
  },
  {
    name: 'Duplicados carnet conducir',
    href: '/generic-procedures/DRIVER_LICENSE_DUPLICATE?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes(
      '/generic-procedures/DRIVER_LICENSE_DUPLICATE',
    ),
  },
  {
    name: 'DUAs',
    href: '/generic-procedures/SINGLE_ADMINISTRATIVE_DOCUMENT?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes(
      '/generic-procedures/SINGLE_ADMINISTRATIVE_DOCUMENT',
    ),
  },
  {
    name: 'Reformas',
    href: '/generic-procedures/REFORM?page=0&dateSort=DESC',
    icon: FolderIcon,
    current: location.pathname.includes('/generic-procedures/REFORM'),
  },
];

export const getInsuranceItems = (location: Location): MenuItem[] => [
  {
    name: 'Garantías Mecánicas',
    href: '/mechanical-warranties?page=0',
    icon: ShieldCheckIcon,
    current: location.pathname.includes('/mechanical-warranties'),
  },
];

export const getToolItems = (location: Location): MenuItem[] => [
  {
    name: 'Calculadoras',
    href: '/tools',
    icon: CalculatorIcon,
    current: location.pathname.includes('/tools'),
  },
];

export const getNavigationCompanyItems = (location: Location): MenuItem[] => [
  {
    name: 'Facturación',
    href: '/invoices',
    icon: DocumentTextIcon,
    current: location.pathname.includes('/invoices'),
  },
  {
    name: 'Configuración',
    href: '/settings',
    icon: CogIcon,
    current: location.pathname.includes('/settings'),
  },
];

export const getDeveloperItems = (location: Location): MenuItem[] => [
  {
    name: 'Webhooks',
    href: '/developers/webhooks',
    icon: CodeIcon,
    current: location.pathname.includes('/developers/webhooks'),
  },
];
